<div class="modal fade show" style="display: block; background-color: rgba(0,0,0,0.5); z-index: 1000;">

  <div class="modal-dialog modal-dialog-centered modal-lg">

    <div class="modal-content w-auto" style="border-radius: 16px; border: none;">

      <div class="modal-body p-0">

        <div class="text-center">
          <img src="/assets/images/banner-agradecimento.png" class="rounded-16 img-fluid"
            alt="Banner de Agradecimento"/>
        </div>

        <!-- SOLICITADO COMENTAR O TRECHO A PEDIDO DE GAUTIERY -->
        <!-- <div>
          <div *ngIf="volumeContratado && volumeContratado.length > 0" class="mt-8 p-4 table-responsive">
            <h6 class="mb-2">Produtos e Volumes Contratados</h6>
            <table class="table table-striped table-bordered">
              <thead class="thead-light">
                <tr>
                  <th scope="col">Produto</th>
                  <th scope="col">Volume</th>
                  <th scope="col">Contrato</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of volumeContratado">
                  <td>{{ item.nomeProduto }}</td>
                  <td>{{ formatMoney(item.volumeContratado) }}</td>
                  <td>
                    <a href="javascript:void(0);" (click)="openContratoPdf(item.idContratoCliente)">
                      Visualizar
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div> -->

      <div class="modal-footer">
        <div class="d-flex align-items-center justify-content-between w-100">
          <div>
            <mat-checkbox [(ngModel)]="aceite" id="termoFidelidade"></mat-checkbox>
            <label class="form-check-label" for="termoFidelidade">
              Li e estou de acordo com os
              <a href="javascript:void(0);" (click)="openTermosDeServico()">termos dos serviços</a> da {{ site }}
            </label>
          </div>
          <button type="button" mat-flat-button (click)="submitForm()">Avançar</button>
        </div>
      </div>

    </div>
  </div>
</div>
